import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  messages: [],
  conversationId: "",
};

const reportingChatSlice = createSlice({
  name: "reportingChat",
  initialState,
  reducers: {
    setMessages(state, action) {
      state.messages = Array.isArray(action.payload) ? action.payload : [];
    },
    setConversationId(state, action) {
      state.conversationId = action.payload ?? "";
    },
    resetChat(state) {
      state.messages = [];
      state.conversationId = "";
    },
  },
});

export const {
  setMessages,
  setConversationId,
  resetChat,
} = reportingChatSlice.actions;

export default reportingChatSlice.reducer;


